import { Space, Typography } from 'antd'
import { useProjectSettingsContext } from '../../../../../../ProjectSettingsContext'
import CIMSBasicFields from 'components/CIMSBasicFields'
import { HelpMessage } from 'utils/constants'
import { IFIReportType, LotCompactionLevel } from 'shared'
import CIMSCollapse from 'components/CIMSCollapse'
import EnabledIndicator from '../../../../components/EnabledIndicator'
import { dateFormatter } from '../../../../../../../../../../../../../utils/dateFormatter'

const Help = HelpMessage.Administration.ProjectSettings.IFITracker
const { count, proctor, lotCompaction, testCompaction } =
  IFIReportType.Lot.defaultMessages

const DensityLotViewPanel: React.VFC = () => {
  const {
    lotIFISettings: { data },
  } = useProjectSettingsContext()

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <CIMSBasicFields
        fields={[
          {
            label: 'Effective Date',
            help: Help.EffectiveDate,
            children: dateFormatter.simple(data?.effectiveDate),
          },
        ]}
      />
      <CIMSCollapse
        multiple
        panels={[
          {
            header: {
              children: 'Test Count',
            },
            key: `view-test-count-${IFIReportType.Lot.id}`,
            extra: {
              children: <EnabledIndicator enabled={data?.testCount?.enabled} />,
            },
            children: (
              <Space direction="vertical" size="middle">
                <Typography>
                  If the number of active Density Tests is less than the Number
                  of Required Tests, issue an Identified Field Issue using the
                  Message.
                </Typography>
                <CIMSBasicFields
                  fields={[
                    {
                      label: 'Message',
                      help: Help.FailureMessage(),
                      children: data?.testCount?.message ?? count,
                    },
                  ]}
                />
              </Space>
            ),
          },
          {
            header: {
              children: 'Proctor',
            },
            key: `view-proctor-${IFIReportType.Lot.id}`,
            extra: {
              children: <EnabledIndicator enabled={data?.proctor?.enabled} />,
            },
            children: (
              <Space direction="vertical" size="middle">
                <Typography>
                  If closed and missing a Global Proctor Value, issue an
                  Identified Field Issue description using the Message.
                </Typography>
                <CIMSBasicFields
                  fields={[
                    {
                      label: 'Message',
                      help: Help.FailureMessage(),
                      children: data?.proctor?.message ?? proctor,
                    },
                  ]}
                />
              </Space>
            ),
          },
          {
            header: {
              children: 'Compaction',
            },
            key: `view-compaction-${IFIReportType.ConcreteTest.id}`,
            extra: {
              children: (
                <EnabledIndicator enabled={data?.compaction?.enabled} />
              ),
            },
            children: (
              <Space direction="vertical" size="middle">
                <Typography>
                  {
                    LotCompactionLevel.fromId(data?.compaction?.levelId)
                      ?.description
                  }
                </Typography>
                <CIMSBasicFields
                  fields={[
                    {
                      label: 'Compaction Level',
                      help: Help.CompactionLevel,
                      children:
                        LotCompactionLevel.fromId(data?.compaction?.levelId)
                          ?.label ?? LotCompactionLevel.Lot.label,
                    },
                    {
                      label: 'Message',
                      help: Help.FailureMessage(),
                      children:
                        data?.compaction?.message ??
                        (data?.compaction?.levelId ===
                        LotCompactionLevel.Test.id
                          ? testCompaction
                          : lotCompaction),
                    },
                  ]}
                />
              </Space>
            ),
          },
        ]}
      />
    </Space>
  )
}

export default DensityLotViewPanel
